export const BATCH_SERVICES_URL: string = '/v1/batch-services';
export const BATCH_TYPES_URL: string = '/v1/batch-types';
export const BATCHES_URL: string = '/v1/batches';
